/** Non-durable policy hints only refresh metadata; never touch list resources. */
export function mergeViewsPolicy(previous = {}, incoming = {}) {
  const next = { ...previous };
  Object.entries(incoming).forEach(([scope, value]) => {
    if (!value.views_policy_version || value.views_policy_version !== previous[scope]?.views_policy_version) next[scope] = value;
  });
  return next;
}

export function createViewsPolicyRefresh({ getViews, fetchViews, apply, onError, delay = 150 }) {
  let disposed = false;
  const pending = new Map();
  const running = new Set();
  let timer;
  async function drain() {
    timer = null;
    await Promise.all([...pending.keys()].filter(scope => !running.has(scope)).map(async scope => {
      const version = pending.get(scope);
      pending.delete(scope);
      if (getViews()[scope]?.views_policy_version === version) return;
      running.add(scope);
      try {
        const value = await fetchViews(scope);
        if (!disposed) apply(scope, value);
      } catch (error) { if (!disposed) onError?.(error); }
      finally {
        running.delete(scope);
        if (!disposed && pending.size && !timer) timer = setTimeout(drain, delay);
      }
    }));
  }
  return {
    receive(event) {
      if (disposed || typeof event?.views_policy_version !== 'string' || !Array.isArray(event.channel_account_ids)) return;
      const views = getViews();
      event.channel_account_ids.forEach(scope => {
        if (views[scope] && views[scope].views_policy_version !== event.views_policy_version) pending.set(scope, event.views_policy_version);
      });
      if (pending.size && !timer) timer = setTimeout(drain, delay);
    },
    dispose() { disposed = true; clearTimeout(timer); pending.clear(); },
  };
}
